import React, { useEffect, useEffectEvent, useState } from "react";
import "./styles/root.css";
import "./styles/App.css";
import "ionicons";
import { useCompaniesStore, useOrganizationsStore } from "./store";
import SearchOverlay from "./components/common/search-overlay";
import OrganizationMap from "./components/map/organization-map";
import FullscreenLoader from "./components/common/fullscreen-loader";
import FullscreenError from "./components/common/fullscreen-error";
import { RMRLogoCard } from "./components/common/rmr-logo-card";

function App() {
    const { isLoading: isOrganizationLoading, error: organizationError } = useOrganizationsStore(
        (state) => state,
    );
    const { isLoading: isCompanyLoading, error: companyError } = useCompaniesStore(
        (state) => state
    );

    const [mode, setMode] = useState<"expanded" | "collapsed">("collapsed");
    const [rmrIsOpen, setRmrIsOpen] = useState<boolean>(false);
    const [rmrShouldNavigate, setRmrShouldNavigate] = useState<boolean>(false);
    const [rmrIsVisible, setRmrIsVisible] = useState<boolean>(false);

    useEffect(() => {
        if(rmrIsOpen) setMode("collapsed");
    }, [rmrIsOpen]);

    useEffect(() => {
        if(organizationError || companyError) {
            console.error("Ошибка загрузки:", companyError, organizationError);
        }
    }, [organizationError, companyError]);

    return (
        <div className="main">
            {isCompanyLoading || isOrganizationLoading ? (
                <FullscreenLoader />
            ) : organizationError || companyError ? (
                <FullscreenError
                    message="Ошибка загрузки данных"
                    onRetry={() => window.location.reload()}
                />
            ) : (
                <div>
                    <OrganizationMap 
                        rmrIsVisible={rmrIsVisible}
                        setRmrIsVisible={setRmrIsVisible}
                        overlayMode={mode}
                        rmrIsOpen={rmrIsOpen} 
                        setRmrIsOpen={setRmrIsOpen}
                        rmrShouldNavigate={rmrShouldNavigate}
                        setRmrShouldNavigate={setRmrShouldNavigate}
                    />
                    <SearchOverlay mode={mode} setMode={setMode}/>
                    <RMRLogoCard onClick={() => {
                        setRmrShouldNavigate(true);
                        setRmrIsOpen(true);
                    }}/>
                </div>
            )}
        </div>
    );
}

export default App;
